(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-manager/assets/javascripts/draw-manager.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-manager/assets/javascripts/draw-manager.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState,
  useMemo = _React.useMemo;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const getDisplayName = svs.utils.products.getDisplayName;
const analytics = svs.components.analytics;
const _svs$components$tipse = svs.components.tipsen.drawManager.utils,
  composeDrawWithFunds = _svs$components$tipse.composeDrawWithFunds,
  useHandleSortDraws = _svs$components$tipse.useHandleSortDraws,
  useFilterDraws = _svs$components$tipse.useFilterDraws;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD;
const selectCurrentDrawsByProduct = svs.components.tipsen.selectors.selectCurrentDrawsByProduct;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const _svs$components$tipse2 = svs.components.tipsen.hooks,
  useBranding = _svs$components$tipse2.useBranding,
  useLockedDraw = _svs$components$tipse2.useLockedDraw;
const _svs$components$tipse3 = svs.components.tipsen.drawManager,
  DrawManagerContent = _svs$components$tipse3.DrawManagerContent,
  DrawManagerModal = _svs$components$tipse3.DrawManagerModal;
const loadNetSaleForDraws = svs.components.sport.drawsRedux.actions.loadNetSaleForDraws;
const selectAllFunds = svs.components.sport.drawsRedux.selectors.selectAllFunds;
const getProductBrandByDraw = svs.components.lbUtils.brandMapping.fn.getProductBrandByDraw;
const TEN_SECONDS_CACHE = 10000;
const DrawManager = () => {
  const isMediumDevice = useMediaQuery(breakpoints.up(BREAKPOINT_MD));
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDrawSelectorVisible = _useState2[0],
    setIsDrawSelectorVisible = _useState2[1];
  const _useCurrentDraw = useCurrentDraw(),
    currentDrawNumber = _useCurrentDraw.drawNumber;
  const draw = useCurrentDraw();
  const brandingList = useBranding();
  const brandingByDraw = getProductBrandByDraw(draw);
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  const draws = useSelector(selectCurrentDrawsByProduct);
  const dispatch = useDispatch();
  const lastNetSaleFetchTimestamp = useRef();
  const lastDrawNumber = useRef(currentDrawNumber);
  const isLockedDraw = useLockedDraw();
  const allFunds = useSelector(selectAllFunds);
  const drawsWithExtraMoney = composeDrawWithFunds(draws, allFunds);
  const filteredDraws = useFilterDraws(drawsWithExtraMoney);
  const sortedDrawsData = useHandleSortDraws(filteredDraws);
  const hasExtraMoneyValue = useMemo(() => sortedDrawsData.some(draw => Object.keys(draw.extraMoney).length > 0), [sortedDrawsData]);
  const sportTypes = useMemo(() => {
    const sports = new Set();
    drawsWithExtraMoney.forEach(draw => {
      sports.add(draw.sportType);
    });
    return [...sports];
  }, [drawsWithExtraMoney]);
  const currentDraw = drawsWithExtraMoney.length > 0 ? drawsWithExtraMoney.filter(_ref => {
    let drawNumber = _ref.drawNumber;
    return drawNumber === currentDrawNumber;
  })[0] : {};
  const shouldEnableDrawSelector = draws.length > 1 && !isLockedDraw;
  const shouldShowDrawManagerModal = !isMediumDevice && shouldEnableDrawSelector && isDrawSelectorVisible;
  const toggleDrawSelector = useCallback(async shouldBeVisible => {
    if (typeof shouldBeVisible === 'boolean') {
      setIsDrawSelectorVisible(shouldBeVisible);
    } else {
      setIsDrawSelectorVisible(current => !current);
    }
  }, []);
  useEffect(() => {
    if (!isDrawSelectorVisible && currentDrawNumber !== lastDrawNumber.current) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
    if (isDrawSelectorVisible) {
      const currentTimestamp = Date.now();
      const shouldFetchNetSales = !lastNetSaleFetchTimestamp.current || currentTimestamp - lastNetSaleFetchTimestamp.current > TEN_SECONDS_CACHE;
      analytics.trackEvent({
        category: "Nya tipsen",
        action: 'change_draw_button_clicked',
        opt_label: getDisplayName(currentDraw.productId)
      });
      if (shouldFetchNetSales) {
        dispatch(loadNetSaleForDraws({
          productId: currentDraw.productId
        }));
        lastNetSaleFetchTimestamp.current = Date.now();
      }
    }
    lastDrawNumber.current = currentDrawNumber;
  }, [currentDraw.productId, currentDrawNumber, dispatch, isDrawSelectorVisible]);
  if (!currentDraw) {
    return null;
  }
  if (shouldShowDrawManagerModal) {
    return React.createElement(DrawManagerModal, {
      currentDrawNumber: currentDrawNumber,
      draws: sortedDrawsData,
      hasExtraMoneyValue: hasExtraMoneyValue,
      isOpen: isDrawSelectorVisible,
      productBranding: branding,
      sportTypes: sportTypes,
      toggleDrawSelector: toggleDrawSelector
    });
  }
  return React.createElement(DrawManagerContent, {
    currentDraw: currentDraw,
    draws: sortedDrawsData,
    hasExtraMoneyValue: hasExtraMoneyValue,
    isDrawSelectorVisible: isDrawSelectorVisible,
    isMediumDevice: isMediumDevice,
    productBranding: branding,
    shouldEnableDrawSelector: shouldEnableDrawSelector,
    sportTypes: sportTypes,
    toggleDrawSelector: toggleDrawSelector
  });
};
setGlobal('svs.components.tipsen.drawManager.DrawManager', DrawManager);

 })(window);